import { populate } from 'populate';import dragonBones from 'pixi-dragonbones';

const raw = {
  width: 1350,
  height: 760,
  x: 0,
  y: 0,
  list: [
    {
      id: '22822e29-22cc-43b6-a233-0bc797ed6d85',
      type: 'Container',
      name: 'root',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '',
      data: ''
    },
    {
      id: 'e9d54290-a5a8-4bcd-af4b-611087b3fbcf',
      type: 'Sprite',
      name: 'farmBg',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'my_farm_bg',
      parent: '22822e29-22cc-43b6-a233-0bc797ed6d85',
      data: ''
    },
    {
      id: 'bef81d25-09bb-453c-a75e-11153b3e73c9',
      type: 'Sprite',
      name: 'farmUI',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: '',
      parent: '22822e29-22cc-43b6-a233-0bc797ed6d85',
      data: ''
    },
    {
      id: '97fd18cc-d769-425a-b578-5715c5d15f14',
      type: 'Container',
      name: 'farmEffects',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '22822e29-22cc-43b6-a233-0bc797ed6d85',
      data: ''
    },
    {
      id: '6ba721a7-1163-43cc-ac92-95eed6fe3bf4',
      type: 'Container',
      name: '',
      nameSpace: 'areaContainer',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'e9d54290-a5a8-4bcd-af4b-611087b3fbcf',
      data: ''
    },
    {
      id: 'b7ef3ea1-b3cf-4d0f-a0d1-f5c9d90adce7',
      type: 'Container',
      name: 'petContainer',
      nameSpace: '',
      className: '',
      x: 1083,
      y: 440,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'e9d54290-a5a8-4bcd-af4b-611087b3fbcf',
      data: ''
    },
    {
      id: 'd3ea5e59-ea36-4181-8493-f833341f6351',
      type: 'Container',
      name: 'effectsContainer',
      nameSpace: '',
      className: '',
      x: 675,
      y: 380,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'e9d54290-a5a8-4bcd-af4b-611087b3fbcf',
      data: ''
    },
    {
      id: 'bea71052-f7f8-4acf-ac4e-daaf184126bb',
      type: 'Container',
      name: 'area_1',
      nameSpace: 'area[]',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '6ba721a7-1163-43cc-ac92-95eed6fe3bf4',
      data: ''
    },
    {
      id: 'f89ce00e-ab8b-4885-9272-f3fc3ae5cd7d',
      type: 'Container',
      name: 'area_0',
      nameSpace: 'area[]',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '6ba721a7-1163-43cc-ac92-95eed6fe3bf4',
      data: ''
    },
    {
      id: '835386cb-6389-48c0-8254-5fcd4a762841',
      type: 'Container',
      name: 'area_2',
      nameSpace: 'area[]',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '6ba721a7-1163-43cc-ac92-95eed6fe3bf4',
      data: ''
    },
    {
      id: '7b62c210-b739-4f74-b818-d57250b00af0',
      type: 'Container',
      name: 'area_3',
      nameSpace: 'area[]',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '6ba721a7-1163-43cc-ac92-95eed6fe3bf4',
      data: ''
    },
    {
      id: '0e7d2279-d2ce-4436-9bf6-f62a73720992',
      type: 'Container',
      name: 'area_4',
      nameSpace: 'area[]',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '6ba721a7-1163-43cc-ac92-95eed6fe3bf4',
      data: ''
    },
    {
      id: 'f29aa79d-9e62-49b0-aeba-264f3de0053e',
      type: 'Graphics',
      name: 'border_area',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      parent: 'bea71052-f7f8-4acf-ac4e-daaf184126bb',
      bake: false,
      commands: [
        {
          id: '70e08b87-d8d4-40fd-b4f7-ae17e2845fcb',
          type: 'beginFill',
          color: 7985985,
          alpha: 0
        },
        {
          id: 'ed491758-8e84-4aa1-93bb-69d35fcc1ca4',
          type: 'lineStyle',
          width: 4,
          color: 7985985,
          alpha: 1,
          alignment: 0.5,
          native: false
        },
        {
          id: '1f087d2f-af63-4295-83da-3ec6cf18a1e7',
          type: 'drawPolygon',
          path: '-25,-25, -30,161, 184,277, 227,247, 344,314, 555,173, 147,-55,-25,-25'
        }
      ],
      data: ''
    },
    {
      id: '58197bfe-c33c-47e2-b58b-368a45e62e17',
      type: 'Container',
      name: 'slotsContainer',
      nameSpace: 'slots',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'bea71052-f7f8-4acf-ac4e-daaf184126bb',
      data: ''
    },
    {
      id: '958bd205-32e9-4bc3-bbd4-86bd8f86fc60',
      type: 'Graphics',
      name: 'border_area',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      parent: 'f89ce00e-ab8b-4885-9272-f3fc3ae5cd7d',
      bake: false,
      commands: [],
      data: ''
    },
    {
      id: '9f8bf7dd-2088-47a2-b157-dddd08d476f0',
      type: 'Container',
      name: 'slotsContainer',
      nameSpace: 'slots',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'f89ce00e-ab8b-4885-9272-f3fc3ae5cd7d',
      data: ''
    },
    {
      id: '79d142c1-36bd-497d-a04f-06208c068a6c',
      type: 'Graphics',
      name: 'border_area',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      parent: '835386cb-6389-48c0-8254-5fcd4a762841',
      bake: false,
      commands: [
        {
          id: '70e08b87-d8d4-40fd-b4f7-ae17e2845fcb',
          type: 'beginFill',
          color: 7985985,
          alpha: 0
        },
        {
          id: 'ed491758-8e84-4aa1-93bb-69d35fcc1ca4',
          type: 'lineStyle',
          width: 4,
          color: 7985985,
          alpha: 1,
          alignment: 0.5,
          native: false
        },
        {
          id: '1f087d2f-af63-4295-83da-3ec6cf18a1e7',
          type: 'drawPolygon',
          path: '660,640,950,797, 1172,794, 1383,678, 1376,580, 1190,453,660,640'
        }
      ],
      data: ''
    },
    {
      id: '835bff73-69b8-498f-a0a3-b329241a5172',
      type: 'Container',
      name: 'slotsContainer',
      nameSpace: 'slots',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '835386cb-6389-48c0-8254-5fcd4a762841',
      data: ''
    },
    {
      id: '25b4ca91-799e-4b58-adbd-a2ab7e6bb3bb',
      type: 'Graphics',
      name: 'border_area',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      parent: '7b62c210-b739-4f74-b818-d57250b00af0',
      bake: false,
      commands: [
        {
          id: '70e08b87-d8d4-40fd-b4f7-ae17e2845fcb',
          type: 'beginFill',
          color: 7985985,
          alpha: 0
        },
        {
          id: 'ed491758-8e84-4aa1-93bb-69d35fcc1ca4',
          type: 'lineStyle',
          width: 4,
          color: 7985985,
          alpha: 1,
          alignment: 0.5,
          native: false
        },
        {
          id: '1f087d2f-af63-4295-83da-3ec6cf18a1e7',
          type: 'drawPolygon',
          path: '337,474, 220,540, 310,583, -20,766, 526,796, 883,775,337,474'
        }
      ],
      data: ''
    },
    {
      id: 'c06a188e-0347-4dd2-ab15-6e51f220db87',
      type: 'Container',
      name: 'slotsContainer',
      nameSpace: 'slots',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '7b62c210-b739-4f74-b818-d57250b00af0',
      data: ''
    },
    {
      id: '5e940bf8-b49c-4241-a9f7-e81aae78f2fa',
      type: 'Graphics',
      name: 'border_area',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      parent: '0e7d2279-d2ce-4436-9bf6-f62a73720992',
      bake: false,
      commands: [
        {
          id: '70e08b87-d8d4-40fd-b4f7-ae17e2845fcb',
          type: 'beginFill',
          color: 7985985,
          alpha: 0
        },
        {
          id: 'ed491758-8e84-4aa1-93bb-69d35fcc1ca4',
          type: 'lineStyle',
          width: 4,
          color: 7985985,
          alpha: 1,
          alignment: 0.5,
          native: false
        },
        {
          id: '1f087d2f-af63-4295-83da-3ec6cf18a1e7',
          type: 'drawPolygon',
          path: '290,583,198,542, 325,466, 96,371, -25,403, -27,754,290,583'
        }
      ],
      data: ''
    },
    {
      id: '553fab4a-4542-4878-a6d2-45b5d0d34146',
      type: 'Container',
      name: 'slotsContainer',
      nameSpace: 'slots',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '0e7d2279-d2ce-4436-9bf6-f62a73720992',
      data: ''
    },
    {
      id: '90f5ab84-038d-4016-9011-e13e10cc8483',
      type: 'Sprite',
      name: 'saleSign',
      nameSpace: '',
      className: '',
      x: 207,
      y: 106,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'my_farm_sale',
      parent: 'f29aa79d-9e62-49b0-aeba-264f3de0053e',
      data: ''
    },
    {
      id: '6af64af7-be6a-41a3-b731-e691e3df5f54',
      type: 'Container',
      name: 'crop_14',
      nameSpace: '',
      className: '',
      x: 174,
      y: 92,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '58197bfe-c33c-47e2-b58b-368a45e62e17',
      data: ''
    },
    {
      id: '6dcf39bb-be81-46f3-b3c4-be72fda2c531',
      type: 'Container',
      name: 'crop_16',
      nameSpace: '',
      className: '',
      x: 79,
      y: 150,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '58197bfe-c33c-47e2-b58b-368a45e62e17',
      data: ''
    },
    {
      id: '7644e8a9-7749-475a-bd24-46c7815df8fc',
      type: 'Container',
      name: 'crop_13',
      nameSpace: '',
      className: '',
      x: 276,
      y: 146,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '58197bfe-c33c-47e2-b58b-368a45e62e17',
      data: ''
    },
    {
      id: '641a1913-59e2-443d-9511-c42573e5e510',
      type: 'Container',
      name: 'crop_15',
      nameSpace: '',
      className: '',
      x: 176,
      y: 203,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '58197bfe-c33c-47e2-b58b-368a45e62e17',
      data: ''
    },
    {
      id: 'a7993d87-64c9-415f-bcdb-d57d8e84df7a',
      type: 'Container',
      name: 'small_3',
      nameSpace: '',
      className: '',
      x: 420,
      y: 141,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '58197bfe-c33c-47e2-b58b-368a45e62e17',
      data: ''
    },
    {
      id: 'c101d8a4-e94f-4042-a942-a87933a912f3',
      type: 'Container',
      name: 'small_4',
      nameSpace: '',
      className: '',
      x: 322,
      y: 222,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '58197bfe-c33c-47e2-b58b-368a45e62e17',
      data: ''
    },
    {
      id: '285f0318-adf6-4aad-baa6-c894ed7745cd',
      type: 'Sprite',
      name: 'saleSign',
      nameSpace: '',
      className: '',
      x: 207,
      y: 106,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'my_farm_sale',
      parent: '958bd205-32e9-4bc3-bbd4-86bd8f86fc60',
      data: ''
    },
    {
      id: '058da426-ddcd-4f4c-a35a-694cb2833013',
      type: 'Container',
      name: 'crop_2',
      nameSpace: '',
      className: '',
      x: 897,
      y: 53,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '9f8bf7dd-2088-47a2-b157-dddd08d476f0',
      data: ''
    },
    {
      id: '81b7d6bf-efd8-458b-a698-6563c3b3c2d2',
      type: 'Container',
      name: 'crop_4',
      nameSpace: '',
      className: '',
      x: 699,
      y: 53,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '9f8bf7dd-2088-47a2-b157-dddd08d476f0',
      data: ''
    },
    {
      id: '0413321c-6bc9-46b5-9685-34475f06e1a1',
      type: 'Container',
      name: 'crop_3',
      nameSpace: '',
      className: '',
      x: 797,
      y: 100,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '9f8bf7dd-2088-47a2-b157-dddd08d476f0',
      data: ''
    },
    {
      id: '036fc972-6abc-4b45-a73c-c68c20fa3b01',
      type: 'Container',
      name: 'crop_5',
      nameSpace: '',
      className: '',
      x: 596,
      y: 100,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '9f8bf7dd-2088-47a2-b157-dddd08d476f0',
      data: ''
    },
    {
      id: 'd0d5199c-fea4-48bb-a104-7a7cbdc70a5b',
      type: 'Container',
      name: 'crop_0',
      nameSpace: '',
      className: '',
      x: 996,
      y: 100,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '9f8bf7dd-2088-47a2-b157-dddd08d476f0',
      data: ''
    },
    {
      id: 'b841269d-894b-40f6-95a6-c09caed04826',
      type: 'Container',
      name: 'crop_1',
      nameSpace: '',
      className: '',
      x: 897,
      y: 150,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '9f8bf7dd-2088-47a2-b157-dddd08d476f0',
      data: ''
    },
    {
      id: '334c900d-93e8-41ad-ae64-a20778ec3768',
      type: 'Container',
      name: 'small_0',
      nameSpace: '',
      className: '',
      x: 1061,
      y: 166,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '9f8bf7dd-2088-47a2-b157-dddd08d476f0',
      data: ''
    },
    {
      id: '49cf7d54-e821-4ea6-8300-b60fdd7b7bac',
      type: 'Container',
      name: 'big_0',
      nameSpace: '',
      className: '',
      x: 725,
      y: 184,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '9f8bf7dd-2088-47a2-b157-dddd08d476f0',
      data: ''
    },
    {
      id: '76c5cf5f-99e4-488d-a8d4-765f95c34d52',
      type: 'Container',
      name: 'small_1',
      nameSpace: '',
      className: '',
      x: 924,
      y: 236,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '9f8bf7dd-2088-47a2-b157-dddd08d476f0',
      data: ''
    },
    {
      id: '7059ee1f-4528-4091-af1b-c524fff9d5f6',
      type: 'Container',
      name: 'crop_11',
      nameSpace: '',
      className: '',
      x: 558,
      y: 269,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '9f8bf7dd-2088-47a2-b157-dddd08d476f0',
      data: ''
    },
    {
      id: '835fd1ab-457c-4933-bbe3-f3e9a380a5b2',
      type: 'Container',
      name: 'crop_10',
      nameSpace: '',
      className: '',
      x: 655,
      y: 320,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '9f8bf7dd-2088-47a2-b157-dddd08d476f0',
      data: ''
    },
    {
      id: 'bcc4e6b4-22cd-4a0f-a6fd-90f6943d31f5',
      type: 'Container',
      name: 'crop_7',
      nameSpace: '',
      className: '',
      x: 855,
      y: 320,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '9f8bf7dd-2088-47a2-b157-dddd08d476f0',
      data: ''
    },
    {
      id: 'ce4bce8d-ec8b-4096-9028-28ed3f495932',
      type: 'Container',
      name: 'crop_12',
      nameSpace: '',
      className: '',
      x: 500,
      y: 344,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '9f8bf7dd-2088-47a2-b157-dddd08d476f0',
      data: ''
    },
    {
      id: '8aea6d78-c801-419e-a855-6dbcd896c8e0',
      type: 'Container',
      name: 'crop_9',
      nameSpace: '',
      className: '',
      x: 754,
      y: 368,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '9f8bf7dd-2088-47a2-b157-dddd08d476f0',
      data: ''
    },
    {
      id: 'a84c91c4-fd3a-43d8-ab66-9d97851adc2b',
      type: 'Container',
      name: 'small_2',
      nameSpace: '',
      className: '',
      x: 612,
      y: 380,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '9f8bf7dd-2088-47a2-b157-dddd08d476f0',
      data: ''
    },
    {
      id: '4a42642f-cf2f-4acc-beba-b8c2efea499f',
      type: 'Container',
      name: 'crop_6',
      nameSpace: '',
      className: '',
      x: 956,
      y: 368,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '9f8bf7dd-2088-47a2-b157-dddd08d476f0',
      data: ''
    },
    {
      id: 'fd29745a-13de-41db-a3c9-45eef9ca0100',
      type: 'Container',
      name: 'crop_8',
      nameSpace: '',
      className: '',
      x: 854,
      y: 416,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '9f8bf7dd-2088-47a2-b157-dddd08d476f0',
      data: ''
    },
    {
      id: '0287b463-2609-4d5a-ab89-36e771bdb67a',
      type: 'Container',
      name: 'house_0',
      nameSpace: '',
      className: '',
      x: 1203,
      y: 307,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '9f8bf7dd-2088-47a2-b157-dddd08d476f0',
      data: ''
    },
    {
      id: '8c9c8c67-8bb0-4b4d-8ae5-5b9574022dfb',
      type: 'Container',
      name: 'fence_0',
      nameSpace: '',
      className: '',
      x: 674,
      y: 381,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '9f8bf7dd-2088-47a2-b157-dddd08d476f0',
      data: ''
    },
    {
      id: 'cb12677a-3cd4-4f3e-aeaf-a4be9762c354',
      type: 'Sprite',
      name: 'saleSign',
      nameSpace: '',
      className: '',
      x: 1063,
      y: 611,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'my_farm_sale',
      parent: '79d142c1-36bd-497d-a04f-06208c068a6c',
      data: ''
    },
    {
      id: '266de0ad-e91d-41c5-b246-c0db095690be',
      type: 'Container',
      name: 'crop_17',
      nameSpace: '',
      className: '',
      x: 1236,
      y: 586,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '835bff73-69b8-498f-a0a3-b329241a5172',
      data: ''
    },
    {
      id: '4e733ab5-8b78-4acd-94e9-0051e90b0619',
      type: 'Container',
      name: 'small_5',
      nameSpace: '',
      className: '',
      x: 1023,
      y: 539,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '835bff73-69b8-498f-a0a3-b329241a5172',
      data: ''
    },
    {
      id: '29bbffb2-bc67-409d-bc3e-e46e0d1e8418',
      type: 'Container',
      name: 'big_1',
      nameSpace: '',
      className: '',
      x: 855,
      y: 601,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '835bff73-69b8-498f-a0a3-b329241a5172',
      data: ''
    },
    {
      id: '24fe9a5c-f1e1-4d94-98c0-37457844cf0d',
      type: 'Container',
      name: 'crop_18',
      nameSpace: '',
      className: '',
      x: 1139,
      y: 634,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '835bff73-69b8-498f-a0a3-b329241a5172',
      data: ''
    },
    {
      id: '3c411bea-9b1a-4cd3-8fcb-a014e9295945',
      type: 'Container',
      name: 'crop_19',
      nameSpace: '',
      className: '',
      x: 1038,
      y: 681,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '835bff73-69b8-498f-a0a3-b329241a5172',
      data: ''
    },
    {
      id: '9875878c-2dc0-410a-8875-ecfa02585843',
      type: 'Container',
      name: 'crop_21',
      nameSpace: '',
      className: '',
      x: 1240,
      y: 683,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '835bff73-69b8-498f-a0a3-b329241a5172',
      data: ''
    },
    {
      id: 'a8ee0cbb-dae4-44cf-918d-2aef46c70e96',
      type: 'Container',
      name: 'crop_20',
      nameSpace: '',
      className: '',
      x: 938,
      y: 732,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '835bff73-69b8-498f-a0a3-b329241a5172',
      data: ''
    },
    {
      id: 'f03dc56b-c6da-40d7-87cb-91dbbae8b10c',
      type: 'Container',
      name: 'crop_22',
      nameSpace: '',
      className: '',
      x: 1137,
      y: 734,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '835bff73-69b8-498f-a0a3-b329241a5172',
      data: ''
    },
    {
      id: '94e7621c-91a1-43b8-8226-a124348e2954',
      type: 'Sprite',
      name: 'saleSign',
      nameSpace: '',
      className: '',
      x: 433,
      y: 643,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'my_farm_sale',
      parent: '25b4ca91-799e-4b58-adbd-a2ab7e6bb3bb',
      data: ''
    },
    {
      id: '93a2d07c-297f-4aed-8ee0-161de9150142',
      type: 'Container',
      name: 'crop_27',
      nameSpace: '',
      className: '',
      x: 333,
      y: 537,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'c06a188e-0347-4dd2-ab15-6e51f220db87',
      data: ''
    },
    {
      id: 'e288bb0c-3a91-4570-b1a2-2419a91aec6f',
      type: 'Container',
      name: 'crop_26',
      nameSpace: '',
      className: '',
      x: 431,
      y: 586,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'c06a188e-0347-4dd2-ab15-6e51f220db87',
      data: ''
    },
    {
      id: '1d4f271f-6093-4014-b7a6-e67f4352ed7d',
      type: 'Container',
      name: 'crop_25',
      nameSpace: '',
      className: '',
      x: 525,
      y: 635,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'c06a188e-0347-4dd2-ab15-6e51f220db87',
      data: ''
    },
    {
      id: '2dc697b0-338e-4ec0-ac77-37de0e635f80',
      type: 'Container',
      name: 'crop_30',
      nameSpace: '',
      className: '',
      x: 330,
      y: 638,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'c06a188e-0347-4dd2-ab15-6e51f220db87',
      data: ''
    },
    {
      id: '41c8c3e1-47f9-40a0-900e-025d9edae96c',
      type: 'Container',
      name: 'crop_29',
      nameSpace: '',
      className: '',
      x: 429,
      y: 687,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'c06a188e-0347-4dd2-ab15-6e51f220db87',
      data: ''
    },
    {
      id: 'e0c6d817-9b65-4c06-ac73-5746e3af91f5',
      type: 'Container',
      name: 'crop_24',
      nameSpace: '',
      className: '',
      x: 621,
      y: 685,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'c06a188e-0347-4dd2-ab15-6e51f220db87',
      data: ''
    },
    {
      id: '8f1f9f6e-d4aa-4257-ab0a-cad5e64aedf5',
      type: 'Container',
      name: 'crop_23',
      nameSpace: '',
      className: '',
      x: 716,
      y: 735,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'c06a188e-0347-4dd2-ab15-6e51f220db87',
      data: ''
    },
    {
      id: '742e9f46-326f-4992-afb7-9b7975487e36',
      type: 'Container',
      name: 'crop_28',
      nameSpace: '',
      className: '',
      x: 527,
      y: 737,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'c06a188e-0347-4dd2-ab15-6e51f220db87',
      data: ''
    },
    {
      id: '99af2a9a-286d-45de-9b88-791c6f53a4d1',
      type: 'Sprite',
      name: 'saleSign',
      nameSpace: '',
      className: '',
      x: 88,
      y: 513,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'my_farm_sale',
      parent: '5e940bf8-b49c-4241-a9f7-e81aae78f2fa',
      data: ''
    },
    {
      id: '0062c4eb-3b8d-4c1a-8f29-05ceb1678bdf',
      type: 'Container',
      name: 'big_2',
      nameSpace: '',
      className: '',
      x: 129,
      y: 414,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '553fab4a-4542-4878-a6d2-45b5d0d34146',
      data: ''
    },
    {
      id: 'c9c01770-410e-4787-8002-b89b06945f21',
      type: 'Container',
      name: 'small_6',
      nameSpace: '',
      className: '',
      x: 222,
      y: 545,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '553fab4a-4542-4878-a6d2-45b5d0d34146',
      data: ''
    },
    {
      id: '3d86af72-51c5-4626-9429-3908d73be438',
      type: 'Container',
      name: 'small_7',
      nameSpace: '',
      className: '',
      x: 82,
      y: 517,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '553fab4a-4542-4878-a6d2-45b5d0d34146',
      data: ''
    }
  ],
  version: '1.0.x'
} as const;

export class FarmLayout {
  static raw = raw;
  root: PIXI.Container
  farmBg: PIXI.Sprite
  petContainer: PIXI.Container
  effectsContainer: PIXI.Container
  farmUI: PIXI.Sprite
  farmEffects: PIXI.Container
  areaContainer: {
    area_1: PIXI.Container
    area_0: PIXI.Container
    area_2: PIXI.Container
    area_3: PIXI.Container
    area_4: PIXI.Container
    area: ({
      border_area: PIXI.Graphics
      saleSign: PIXI.Sprite
      slotsContainer: PIXI.Container
      slots: {
        crop_14: PIXI.Container
        crop_16: PIXI.Container
        crop_13: PIXI.Container
        crop_15: PIXI.Container
        small_3: PIXI.Container
        small_4: PIXI.Container
        children: (PIXI.Container)[]
      }
      children: (PIXI.Graphics | PIXI.Container)[]
    } | {
      border_area: PIXI.Graphics
      saleSign: PIXI.Sprite
      slotsContainer: PIXI.Container
      slots: {
        crop_2: PIXI.Container
        crop_4: PIXI.Container
        crop_3: PIXI.Container
        crop_5: PIXI.Container
        crop_0: PIXI.Container
        crop_1: PIXI.Container
        small_0: PIXI.Container
        big_0: PIXI.Container
        small_1: PIXI.Container
        crop_11: PIXI.Container
        crop_10: PIXI.Container
        crop_7: PIXI.Container
        crop_12: PIXI.Container
        crop_9: PIXI.Container
        small_2: PIXI.Container
        crop_6: PIXI.Container
        crop_8: PIXI.Container
        house_0: PIXI.Container
        fence_0: PIXI.Container
        children: (PIXI.Container)[]
      }
      children: (PIXI.Graphics | PIXI.Container)[]
    } | {
      border_area: PIXI.Graphics
      saleSign: PIXI.Sprite
      slotsContainer: PIXI.Container
      slots: {
        crop_17: PIXI.Container
        small_5: PIXI.Container
        big_1: PIXI.Container
        crop_18: PIXI.Container
        crop_19: PIXI.Container
        crop_21: PIXI.Container
        crop_20: PIXI.Container
        crop_22: PIXI.Container
        children: (PIXI.Container)[]
      }
      children: (PIXI.Graphics | PIXI.Container)[]
    } | {
      border_area: PIXI.Graphics
      saleSign: PIXI.Sprite
      slotsContainer: PIXI.Container
      slots: {
        crop_27: PIXI.Container
        crop_26: PIXI.Container
        crop_25: PIXI.Container
        crop_30: PIXI.Container
        crop_29: PIXI.Container
        crop_24: PIXI.Container
        crop_23: PIXI.Container
        crop_28: PIXI.Container
        children: (PIXI.Container)[]
      }
      children: (PIXI.Graphics | PIXI.Container)[]
    } | {
      border_area: PIXI.Graphics
      saleSign: PIXI.Sprite
      slotsContainer: PIXI.Container
      slots: {
        big_2: PIXI.Container
        small_6: PIXI.Container
        small_7: PIXI.Container
        children: (PIXI.Container)[]
      }
      children: (PIXI.Graphics | PIXI.Container)[]
    })[]
    children: (PIXI.Container)[]
  }

  constructor() {
    populate(this, raw);
  }
}
